import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';

import styles from './styles.module.scss';

const { Text } = Typography;

const ContentBankruptcy = () => (
  <Space direction="vertical" size={8} className="h-mt-12">
    <Text size={10} className={styles.tag} uppercase strong>
      Бесплатная консультация
    </Text>
    <Text size={14} className="h-color-D100">
      Законное списание долгов – поможем разобраться как это работает
    </Text>
  </Space>
);

export { ContentBankruptcy };
